import { render, staticRenderFns } from "./project-bidders.vue?vue&type=template&id=6d938658&"
import script from "./project-bidders.vue?vue&type=script&lang=js&"
export * from "./project-bidders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports